import type { KyInstance } from 'ky';
import type { PluginConversationCase } from './types/pluginCases';

export function buildPluginCasesApi(http: KyInstance) {
  return {
    get: (id: string) =>
      http
        .get(`api/v1/messaging/conversations/${id}/plugin-cases`)
        .json<PluginConversationCase[]>(),
  };
}
